export default "__VITE_ASSET__BlZD_eWe__"